<template>
  <div class="apn-page apn-contact">
        <!-- Banner -->
        <apn-banner :bg-image="BannerImg" :message="message" />
        <!-- Main -->
        <apn-contact-form />
        <!-- Maps -->
        <div class="google-map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.5708666729147!2d96.1177917146716!3d16.84763202258195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30c19539309a5e31%3A0x13c8bf6b41525bc0!2sThe%20Leaf%20Residence%20%26%20Tower!5e0!3m2!1sen!2sus!4v1610355632654!5m2!1sen!2sus" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
        <!-- Footer -->
        <apn-footer />
  </div>
</template>

<script>
import ApnBanner from '@/components/ApnBanner'
import ApnFooter from '@/components/ApnFooter'
import ApnContactForm from '@/components/ApnContact'
import BannerImg from '@/assets/images/contact-banner.jpg'

export default {
  name: 'ApnContact',
    components: {
        ApnBanner,
        ApnFooter,
        ApnContactForm,
    },
    data() {
        return {
            BannerImg,
            message: {
                header: 'We are ready, Let\'s TALK',
                content: 'Contact us to find out more or how we can help you better.',
            },
        }
    },
}
</script>

<style scoped lang="scss">
.apn-contact {
    .google-map {
        width: 100%;
        height: 400px;
        iframe {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
